import { reset } from 'redux-form';

import { BOOTSTRAP_CIS_FORM } from '../names';

export const resetBootstrapCIsForm = () => reset(BOOTSTRAP_CIS_FORM);
